import { findAllFleets } from '@src/main/modules/parameters/application/find/find-all-fleets.usecase';
import { FleetRepository } from '@src/main/modules/parameters/domain/fleet-positions/fleet.repository';
import { createFleetHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/FleetHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useFleets = () => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<FleetRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createFleetHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['fleet'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findAllFleets(repository);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return { ...queryResult, repository };
};
